import Reflux from 'reflux';
import ItemSetListData from 'shared/data/ItemSetList';
import ShowData from 'shared/data/Show';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

let async = { asyncResult: true };

const asyncReadOnlyCfg = readOnlyHelper.actionConfigFactory(async);
const readOnlyCfg = readOnlyHelper.actionConfigFactory();

let CuesheetColumnActions = Reflux.createActions({
  updateNoteColumnWidth: readOnlyCfg,
  updateNoteColumnWidthPersistent: asyncReadOnlyCfg,
  hideNoteColumn: {},
  hideNoteColumnPersistent: async,
  clearProofOfPerformance: {},
  clearProofOfPerformancePersistent: asyncReadOnlyCfg,
  enableProofTracking: {},
  enableProofTrackingPersistent: asyncReadOnlyCfg,
  disableProofTracking: {},
  disableProofTrackingPersistent: asyncReadOnlyCfg,
  showNoteColumn: {},
  showNoteColumnPersistent: async,
  updateColumnWidth: readOnlyCfg,
  updateColumnWidthPersistent: asyncReadOnlyCfg,
  hideColumn: {},
  hideColumnPersistent: async,
  showColumn: {},
  showColumnPersistent: async,
  showColumns: {},
  showColumnsPersistent: async,
  deleteColumn: readOnlyCfg,
  deleteColumnPersistent: asyncReadOnlyCfg,
  deleteColumnGuestPass: readOnlyCfg,
  deleteColumnGuestPassPersistent: asyncReadOnlyCfg,
  addColumn: readOnlyCfg,
  addColumnPersistent: asyncReadOnlyCfg,
  addColumnGuestPass: readOnlyCfg,
  addColumnGuestPassPersistent: asyncReadOnlyCfg,
  restoreColumn: readOnlyCfg,
  restoreColumnPersistent: asyncReadOnlyCfg,
  moveUserColumnRight: {},
  moveUserColumnLeft: {},
  moveUserColumnPersistent: async,
  moveGuestColumnRight: {},
  moveGuestColumnLeft: {},
  moveGuestColumnPersistent: async,
  moveColumnRight: {},
  moveColumnLeft: {},
  moveColumnPersistent: async,
  hideItemDescriptions: readOnlyCfg,
  showItemDescriptions: readOnlyCfg,
  updateItemColumnWidth: readOnlyCfg,
  updateItemTitleColumnWidth: readOnlyCfg,
  updateItemDescriptionColumnWidth: readOnlyCfg,
  updateColumnWidthGrow: readOnlyCfg,
  updateColumnWidthShrink: readOnlyCfg,
  hideItemDescriptionsPersistent: asyncReadOnlyCfg,
  showItemDescriptionsPersistent: asyncReadOnlyCfg,
  updateItemColumnWidthPersistent: asyncReadOnlyCfg,
  updateItemTitleColumnWidthPersistent: asyncReadOnlyCfg,
  updateItemDescriptionColumnWidthPersistent: asyncReadOnlyCfg,
  saveFeaturedColumn: asyncReadOnlyCfg,
  updateUserSettingsPersistent: asyncReadOnlyCfg,
});

CuesheetColumnActions.moveUserColumnPersistent.listenAndPromise(
  ItemSetListData.moveUserColumn,
);
CuesheetColumnActions.moveGuestColumnPersistent.listenAndPromise(
  ItemSetListData.moveGuestColumn,
);
CuesheetColumnActions.moveColumnPersistent.listenAndPromise(
  ItemSetListData.moveColumn,
);
CuesheetColumnActions.addColumnPersistent.listenAndPromise(
  ItemSetListData.createColumn,
);
CuesheetColumnActions.addColumnGuestPassPersistent.listenAndPromise(
  ItemSetListData.addColumnGuestPass,
);
CuesheetColumnActions.restoreColumnPersistent.listenAndPromise(
  ItemSetListData.restoreColumn,
);
CuesheetColumnActions.deleteColumnPersistent.listenAndPromise(
  ItemSetListData.softDeleteColumn,
);
CuesheetColumnActions.deleteColumnGuestPassPersistent.listenAndPromise(
  ItemSetListData.softDeleteColumnGuestPass,
);
CuesheetColumnActions.hideColumnPersistent.listenAndPromise(
  ItemSetListData.hideUserColumn,
);
CuesheetColumnActions.showColumnPersistent.listenAndPromise(
  ItemSetListData.showUserColumn,
);
CuesheetColumnActions.updateColumnWidthPersistent.listenAndPromise(
  ItemSetListData.updateColumnWidth,
);
CuesheetColumnActions.hideNoteColumnPersistent.listenAndPromise(
  ItemSetListData.hideUserNoteColumn,
);
CuesheetColumnActions.showNoteColumnPersistent.listenAndPromise(
  ItemSetListData.showUserNoteColumn,
);
CuesheetColumnActions.updateNoteColumnWidthPersistent.listenAndPromise(
  ItemSetListData.updateUserNoteColumnWidth,
);
CuesheetColumnActions.updateUserSettingsPersistent.listenAndPromise(
  ItemSetListData.updateUserSettings,
);
CuesheetColumnActions.hideItemDescriptionsPersistent.listenAndPromise(
  ItemSetListData.hideItemColumnDescriptions,
);
CuesheetColumnActions.showItemDescriptionsPersistent.listenAndPromise(
  ItemSetListData.showItemColumnDescriptions,
);

CuesheetColumnActions.disableProofTrackingPersistent.listenAndPromise(
  (teamId, eventId, showId) =>
    ShowData.updateField(
      teamId,
      eventId,
      showId,
      'proofOfPerformanceTracking',
      false,
    ),
);
CuesheetColumnActions.enableProofTrackingPersistent.listenAndPromise(
  (teamId, eventId, showId) =>
    ShowData.updateField(
      teamId,
      eventId,
      showId,
      'proofOfPerformanceTracking',
      true,
    ),
);
CuesheetColumnActions.clearProofOfPerformancePersistent.listenAndPromise(
  ShowData.clearProofOfPerformance,
);

CuesheetColumnActions.updateItemColumnWidthPersistent.listenAndPromise(
  ItemSetListData.updateItemColumnWidth,
);
CuesheetColumnActions.updateItemTitleColumnWidthPersistent.listenAndPromise(
  ItemSetListData.updateItemTitleColumnWidth,
);
CuesheetColumnActions.updateItemDescriptionColumnWidthPersistent.listenAndPromise(
  ItemSetListData.updateItemDescriptionColumnWidth,
);
CuesheetColumnActions.showColumnsPersistent.listenAndPromise(
  ItemSetListData.showUserColumns,
);

export default CuesheetColumnActions;
